export default function calcLength(maxLength: number, currLength: number): number {
    if (maxLength < 0 || currLength < 0) {
        throw new Error('Length values cannot be negative.');
    }

    const remainingLength = maxLength - currLength;

    if (remainingLength < 0) {
        return 0; // Length exceeded the maximum limit
    }

    return remainingLength;
}
